import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import {
  HouseStudyDayIndividualDto,
  SeasonEnum,
} from '../../../../../../../../../../../../lib/graphql'
import { HTLabel } from '../../../../../../../../../../../atoms'
import { ControlledTextField } from '../../../../../../../../../../../forms'
import PriceSeasonColorTag from '../../../../../../../../../shared/components/seasonal-busyness-calendar/components/tag/price-season-color-tag/PriceSeasonColorTag'
import { formatMoney } from '../../../../../../../../../shared/utils/format/format-money/format-money'
import { HouseStudyDayIndividualFieldProps } from '../../../../form-container/HouseStudyDayIndividualFormContainer'

type HouseStudyDayIndividualSeasonalPriceFieldProps =
  HouseStudyDayIndividualFieldProps & {
    name:
      | 'residential.highPrice'
      | 'residential.lowPrice'
      | 'residential.mediumPrice'
      | 'fullDay.highPrice'
      | 'fullDay.mediumPrice'
      | 'fullDay.lowPrice'
      | 'halfDay.highPrice'
      | 'halfDay.lowPrice'
      | 'halfDay.mediumPrice'
  }
export const HouseStudyDayIndividualSeasonalPriceField = ({
  control,
  currencyArea,
  isFieldDisabled,
  name,
}: HouseStudyDayIndividualSeasonalPriceFieldProps) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: {},
    placeholder: formatMoney({ value: 0, currency: currencyArea.currency }),
  }

  const { setValue } = useFormContext<HouseStudyDayIndividualDto>()

  const priceName = name.split('.')[1]
  return (
    <>
      <ControlledTextField
        {...fieldProps}
        formatValue={(value) =>
          formatMoney({ value, currency: currencyArea.currency })
        }
        placeholder={formatMoney({ value: 0, currency: currencyArea.currency })}
        name={`options.seasonalPrices.0.${name}`}
        onReset={() =>
          setValue(`options.seasonalPrices.0.${name}`, null, {
            shouldDirty: true,
          })
        }
        label={
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <PriceSeasonColorTag
              season={
                priceName === 'highPrice'
                  ? SeasonEnum.HIGH
                  : priceName === 'lowPrice'
                    ? SeasonEnum.LOW
                    : SeasonEnum.MEDIUM
              }
            />
            <div>
              <HouseStudyDayIndividualSeasonalPriceFieldLabel name={name} />

              <span style={{ marginLeft: 5 }}>
                <HTLabel />
              </span>
            </div>
          </div>
        }
      />
    </>
  )
}

const HouseStudyDayIndividualSeasonalPriceFieldLabel = ({
  name,
}: Pick<HouseStudyDayIndividualSeasonalPriceFieldProps, 'name'>) => {
  switch (name) {
    case 'residential.highPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.residential.highPrice'
          defaultMessage='Tarif accès aux salles pour le forfait <bold>séminaire résidentiel</bold> haute saison'
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'residential.lowPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.residential.lowPrice'
          defaultMessage='Tarif accès aux salles pour le forfait <bold>séminaire résidentiel</bold> basse saison'
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'residential.mediumPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.residential.mediumPrice'
          defaultMessage='Tarif accès aux salles pour le forfait <bold>séminaire résidentiel</bold> moyenne saison'
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'fullDay.highPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.fullDay.highPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>journée d'étude</bold> haute saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'fullDay.lowPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.fullDay.lowPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>journée d'étude</bold> basse saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'fullDay.mediumPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.fullDay.mediumPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>journée d'étude</bold> moyenne saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'halfDay.highPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.halfDay.highPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>1/2 journée d'étude</bold> haute saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'halfDay.lowPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.halfDay.lowPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>1/2 journée d'étude</bold> basse saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
    case 'halfDay.mediumPrice':
      return (
        <FormattedMessage
          id='ui.HouseStudyDayIndividualFormFields.options.seasonalPrices.0.halfDay.mediumPrice'
          defaultMessage="Tarif accès aux salles pour le forfait <bold>1/2 journée d'étude</bold> moyenne saison"
          values={{ bold: (content) => <b>{content}</b> }}
        />
      )
  }
}
